import React, { useState, useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: { backgroundColor: "#F0F0EA", width: "100%", height: "100%" },
  mainitem: { textAlign: "center", paddingTop: "5rem" },
  maintext: {
    fontSize: "2rem",
    fontWeight: 700,
    textAlign: "center",
    color: "#595A5A",
  },
  secondtexT: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
  itemstep: {
    width: "100%",
    display: "flex",
    textAlign: "center",
    margin: "2rem",
    justifyContent: "center",
  },
  grid: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    paddingTop: "2rem",
  },
}));

const HowtoUse = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  let step = [
    {
      title: lang.CreateAccount,
      image: require("../../../images/graphic-icon/create_account.png"),
    },
    {
      title: lang.Chooseaplan,
      image: require("../../../images/graphic-icon/create_project.png"),
    },
    {
      title: lang.CreateProject,
      image: require("../../../images/graphic-icon/choose_plan.png"),
    },
    {
      title: `${lang.Get}`,
      image: require("../../../images/graphic-icon/get_api.png"),
    },
  ];
  const [stepCount] = useState({ linear: "25%", count: 0 });
  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            height: "100%",
          }}
        >
          <div className={classes.mainitem}>
            <Typography className={classes.maintext}>
              {lang.Howtouse}
            </Typography>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                paddingTop: "1rem",
              }}
            >
              {/* <Typography className={classes.secondtexT}>
                Usu habeo equidem sanctus no. Suas summo id sed, erat erant
                oporteat cu pri. In eum omnes molestie. Sed ad debet scaevola,
                ne mel.
              </Typography> */}
            </div>
          </div>
        </Grid>

        <div className={classes.itemstep}>
          <div>
            <div
              style={{
                width: "100%",
                height: 2,
                backgroundColor: "#595A5A",
              }}
            >
              <div
                style={{
                  width: stepCount.linear,
                  height: 3,
                  backgroundColor: "#E16733",
                }}
              />
            </div>
            <Grid container spacing={6} className={classes.grid}>
              {step.map((item, index) => {
                return (
                  <Grid
                    item
                    md={3}
                    sm={12}
                    key={`${item.title}_${index}`}
                    // style={{ margin: "1.5rem" }}
                    data-aos="fade-right"
                    data-aos-duration={Number(index * 1000)}
                  >
                    <img
                      alt={`img_${item.title}`}
                      src={item.image}
                      style={{
                        width: "auto",
                        maxHeight: 150,
                        objectFit: "cover",
                      }}
                      // onClick={() => {
                      //   setStepCount({
                      //     ...stepCount,
                      //     count: index,
                      //     linear: `${25 * Number(index + 1)}%`,
                      //   });
                      // }}
                    />
                    <Typography
                      style={{
                        color: stepCount.count >= index ? "#E16733" : "#595A5A",
                        fontWeight: 400,
                      }}
                    >{`${index + 1}. ${item.title}`}</Typography>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default HowtoUse;
